import { eTipoPermissao } from '@/enums/ePermissoes';
 
export default [
  {
    description: 'Relatório Biblioteca',
    path: '/biblioteca/relatorios/acervo',
    name: 'relatorios-biblioteca-acervo',
    component: () => import('@/views/biblioteca/relatorios/acervo/Configuracao.vue'),
    meta: {
      permissions: [eTipoPermissao.BIB_RELATORIO_ACERVO_BIBLIOTECA_MENU_1300802201],
    },
    goesToMenu: true,
  },
];
